import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import config from "../Api/config";

function Sidebar({ currentPage }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();

  // ===== CLICK OUTSIDE TO CLOSE =====
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        const toggleBtn = document.getElementById('toggleBtn');
        if (toggleBtn && !toggleBtn.contains(event.target)) {
          setSidebarOpen(false);
        }
      }
    };

    if (sidebarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebarOpen]);

  // ===== TOGGLE SIDEBAR =====
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    if (!sidebarOpen) {
      setMasterOpen(true);
    }
  };

  const handleDownloadPopup = () => {
  try {
    if (!config?.DOWNLOAD_URL) {
      console.error("DOWNLOAD_URL not defined in config");
      return;
    }

    const width = 600;
    const height = 500;

    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    window.open(
      config.DOWNLOAD_URL,
      "DownloadPopup",
      `
        width=${width},
        height=${height},
        left=${left},
        top=${top},
        resizable=no,
        scrollbars=yes,
        toolbar=no,
        menubar=no,
        location=no,
        status=no
      `
    );
  } catch (error) {
    console.error("Popup error:", error);
  }
};



  // ===== SIDEBAR STYLES =====
  const sidebarStyle = {
    position: "fixed",
    left: 0,
    top: 0,
    height: "100vh",
    width: sidebarOpen ? "250px" : "0px",
    background: "linear-gradient(180deg, #2c3e50 0%, #34495e 100%)",
    transition: "width 0.3s ease",
    overflow: "hidden",
    zIndex: 1000,
    boxShadow: sidebarOpen ? "2px 0 10px rgba(0,0,0,0.3)" : "none"
  };

  const toggleBtnStyle = {
    position: "fixed",
    left: "15px",
    top: "70px",
    width: "40px",
    height: "40px",
    background: "#2c3e50",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    zIndex: 1001,
    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
    opacity: sidebarOpen ? 0 : 1,
    pointerEvents: sidebarOpen ? "none" : "auto",
    transition: "opacity 0.3s ease"
  };

  const hamburgerLine = {
    width: "20px",
    height: "2px",
    background: "#fff",
    borderRadius: "2px",
    transition: "all 0.3s ease"
  };

  const mainMenuStyle = {
    color: "#ecf0f1",
    padding: "16px 24px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "15px",
    fontWeight: 600,
    borderBottom: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(52, 73, 94, 0.8)",
    transition: "background 0.2s ease",
    textTransform: "uppercase",
    letterSpacing: "1px"
  };

  const subMenuItemStyle = {
    color: "#95a5a6",
    padding: "12px 24px 12px 44px",
    cursor: "pointer",
    fontSize: "13px",
    display: "block",
    borderBottom: "1px solid rgba(255,255,255,0.05)",
    transition: "all 0.2s ease",
    fontWeight: 400
  };

  return (
    <>
      {/* TOGGLE BUTTON (Hamburger) */}
      <button 
        id="toggleBtn"
        style={toggleBtnStyle}
        onClick={toggleSidebar}
      >
        <div style={hamburgerLine}></div>
        <div style={hamburgerLine}></div>
        <div style={hamburgerLine}></div>
      </button>

      {/* SIDEBAR */}
      <div ref={sidebarRef} style={sidebarStyle}>
        <div style={{ padding: "60px 0 20px 0px" }}>
          {/* Close Button */}
          {sidebarOpen && (
            <div 
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                color: "#fff",
                fontSize: "20px",
                cursor: "pointer",
                padding: "5px 10px"
              }}
              onClick={() => setSidebarOpen(false)}
            >
              ✕
            </div>
          )}
          <div 
            style={{...mainMenuStyle, marginTop: "50px", background: "rgba(52, 73, 94, 0.8)"}}
            onClick={() => setMasterOpen(!masterOpen)}
          >
            <span>Master</span>
            <span style={{ 
              transform: masterOpen ? "rotate(90deg)" : "rotate(0deg)", 
              transition: "transform 0.2s",
              fontSize: "10px"
            }}>▶</span>
          </div>
          
          {masterOpen && (
            <>
              <div 
                style={{
                  ...subMenuItemStyle, 
                  color: currentPage === "partmaster" ? "#fff" : "#b0bec5", 
                  background: currentPage === "partmaster" ? "rgba(255,255,255,0.1)" : "transparent"
                }}
                onClick={() => navigate("/partmaster")}
                onMouseOver={(e) => { e.target.style.color = "#fff"; e.target.style.background = "rgba(255,255,255,0.05)" }}
                onMouseOut={(e) => { 
                  e.target.style.color = currentPage === "partmaster" ? "#fff" : "#b0bec5"; 
                  e.target.style.background = currentPage === "partmaster" ? "rgba(255,255,255,0.1)" : "transparent"; 
                }}
              >
                Part Master
              </div>
              {/* <div 
                style={{
                  ...subMenuItemStyle, 
                  color: currentPage === "addltxt2" ? "#fff" : "#b0bec5", 
                  background: currentPage === "addltxt2" ? "rgba(255,255,255,0.1)" : "transparent"
                }}
                onClick={() => navigate("/addltxt2")}
                onMouseOver={(e) => { e.target.style.color = "#fff"; e.target.style.background = "rgba(255,255,255,0.05)" }}
                onMouseOut={(e) => { 
                  e.target.style.color = currentPage === "addltxt2" ? "#fff" : "#b0bec5"; 
                  e.target.style.background = currentPage === "addltxt2" ? "rgba(255,255,255,0.1)" : "transparent"; 
                }}
              >
                AddlTxt2
              </div> */}
               <div 
                style={{
                  ...subMenuItemStyle, 
                  color: currentPage === "addltxt2" ? "#fff" : "#b0bec5", 
                  background: currentPage === "addltxt2" ? "rgba(255,255,255,0.1)" : "transparent"
                }}
                onClick={() => navigate("/reports")}
                onMouseOver={(e) => { e.target.style.color = "#fff"; e.target.style.background = "rgba(255,255,255,0.05)" }}
                onMouseOut={(e) => { 
                  e.target.style.color = currentPage === "addltxt2" ? "#fff" : "#b0bec5"; 
                  e.target.style.background = currentPage === "addltxt2" ? "rgba(255,255,255,0.1)" : "transparent"; 
                }}
              >
                Reports
              </div>
            </>
          )}
          
          

          {/* Back to Dashboard */}
          <div 
            style={mainMenuStyle}
            onClick={() => navigate("/dashboard")}
          >
            <span>← Back to Dashboard</span>
          </div>

         <div 
  style={{
    ...mainMenuStyle,
    background: "rgba(46, 204, 113, 0.9)"
  }}
  onClick={handleDownloadPopup}
>
  <span>⬇ Download App</span>
</div>
{/* Change Password */}
          <div 
            style={{
              ...mainMenuStyle,
              marginTop: "20px",
              background: "rgba(52, 152, 219, 0.9)"
            }}
            onClick={() => navigate("/changepassword")}
          >
            <span>🔐 Change Password</span>
          </div>

          {/* Logout */}
          <div 
            style={{
              ...mainMenuStyle,
              marginTop: "20px",
              background: "rgba(231, 76, 60, 0.9)"
            }}
            onClick={() => {
              localStorage.removeItem("user");
              navigate("/");
            }}
          >
            <span>🚪 Logout</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
